import { FormControl, FormGroup, Validators } from "@angular/forms";
import { HttpStatusCodesEnum, LookupInterface, LookupModel, ServerResponse, TradingPlanCreateRequestModel, TradingPlanResponseInterface, TradingPlanSearchResponseModel, TradingPlanService, TradingPlanTypeEnum } from "@spa/api";
import { InArrayValidator } from "@spa/validators";
import { CreatePlanControls } from "appAssets/descriptors";
import { TradingPlanFormErrorStatesEnum } from "appEntries/panel/enums";
import { AutocompleteControl, BaseControl, Helper, SelectControl } from "appShared/classes";
import { SelectOptionInterface } from "appShared/components";
import { switchMap } from "rxjs/operators";

export class CreatePlanForm{
    public availablePlanTypes: LookupInterface;
    private tradingPlanService: TradingPlanService;
    public formGroup: FormGroup;
    public controls: BaseControl[];
    FORM_ELEMENT_CCOUNT: number;
    
    constructor(tradingPlanService: TradingPlanService, availablePlanTypes: Record<number, string>) {
        this.tradingPlanService = tradingPlanService;
        this.availablePlanTypes = availablePlanTypes; 
    }

    initForm(): void {

        this.formGroup = new FormGroup({}); 
        
        this.controls = CreatePlanControls()
            .map((control: BaseControl<any>) => {
               
                if (control.name == TradingPlanCreateRequestModel.getPlanTypeSelector()){
                    const ctrl = control as AutocompleteControl; 
                    const options = Helper.enumsHelper().getTradingPlanTypeAsOptions(false, [TradingPlanTypeEnum.All]);
                    ctrl.options =  options;
                    control.extendValidators(InArrayValidator(options.map(option => option.value as number)));
                    control.disabled = ctrl.options.length === 1;
                }
                this.formGroup.addControl(control.name, new FormControl(control.value, control.validators));

                return control;
            });
    }
    
    isDemoValueChanged(e:boolean) {
        const options = Helper.enumsHelper().getTradingPlanTypeAsOptions(e, [TradingPlanTypeEnum.All]);
        const planTypeControl = this.controls[1] as AutocompleteControl; 
        const formControl = this.formGroup.get(TradingPlanCreateRequestModel.getPlanTypeSelector());
        formControl.setValue(null);
        formControl.clearValidators();
        planTypeControl.options.splice(0, planTypeControl.options.length);
        planTypeControl.options.push(...options);
        formControl.setValidators([InArrayValidator(options.map(option => option.value as number))]);  
        formControl.updateValueAndValidity();

    }

    createRequest(): ServerResponse<TradingPlanResponseInterface> {
        if (!this.formGroup.dirty) {
            return null;
        }
 
        const name = this.formGroup.value[TradingPlanCreateRequestModel.getNameSelector()];
        const planType = this.formGroup.value[TradingPlanCreateRequestModel.getPlanTypeSelector()];
        const isDemo = this.formGroup.value[TradingPlanSearchResponseModel.getIsDemoSelector()];

        const inputModel = new TradingPlanCreateRequestModel(planType, name, isDemo);

        return this.tradingPlanService.create(inputModel.serialize())
            .pipe(switchMap(registerResponse => {
                if (registerResponse.status !== HttpStatusCodesEnum.Ok) {
                    return Helper.errorsHelper().createErrorResponseObservable<TradingPlanResponseInterface>(
                        registerResponse,
                        TradingPlanFormErrorStatesEnum.CreatePlanFailed
                    );
                }

                return Helper.createSuccessResponseObservable<TradingPlanResponseInterface>(registerResponse.data as TradingPlanResponseInterface);

            }));
    }    

    validateForm(messagesFunction: (controlsLabel?: string) => { [key: string]: string }): boolean {
        const statusesCheck = this.controls.map((control: BaseControl) => {
            const formControl = this.formGroup.controls[control.name];

            if (formControl && formControl.invalid) {
                control.errors = Object.keys(formControl.errors).map((key: string) => {
                    return messagesFunction(control.placeholder)[key];
                });

                return false;
            }

            return true;
        });

        return statusesCheck.indexOf(false) < 0;
    }
}
